import { ReactNode } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { AuthPage } from '../../pages/AuthPage';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Protected Route Component
 * Shows authentication page if user is not logged in,
 * otherwise shows the protected content
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, loading } = useAuth();

  // Show loading spinner while checking authentication status
  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        bgcolor="background.default"
      >
        <CircularProgress size={40} sx={{ mb: 2 }} />
        <Typography variant="body1" color="text.secondary">
          Loading TimeLynxx Admin Portal...
        </Typography>
      </Box>
    );
  }

  // Show authentication page if user is not authenticated
  if (!isAuthenticated) {
    return <AuthPage />;
  }

  // Show protected content if user is authenticated
  return <>{children}</>;
}